__turbopack_context__.v({
  "loaderBox": "Loader-module__AdlJEq__loaderBox",
  "loaderWrapper": "Loader-module__AdlJEq__loaderWrapper",
  "refreshing-loader": "Loader-module__AdlJEq__refreshing-loader",
});
